const LeaseRow = ({ label, value }: { label: string; value: string }) => (
  <>
    <span className='lease-key dark-grey content-normal'>{label}</span>
    <span className='lease-value content-normal'>{value}</span>
  </>
);

export default LeaseRow;
